export default function CouponPastH5(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="327" height="158" viewBox="0 0 327 158" fill="none" {...props}>
            <mask id="path-1-inside-1_3208_27366" fill="white">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10C0 4.47715 4.47715 0 10 0H317C322.523 0 327 4.47715 327 10V68C315.954 68 307 76.7854 307 87.6226C307 98.4599 315.954 107.245 327 107.245V148C327 153.523 322.523 158 317 158H10C4.47716 158 0 153.523 0 148V107.245C11.0457 107.245 20 98.4599 20 87.6226C20 76.7854 11.0457 68 0 68V10Z"
                />
            </mask>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 10C0 4.47715 4.47715 0 10 0H317C322.523 0 327 4.47715 327 10V68C315.954 68 307 76.7854 307 87.6226C307 98.4599 315.954 107.245 327 107.245V148C327 153.523 322.523 158 317 158H10C4.47716 158 0 153.523 0 148V107.245C11.0457 107.245 20 98.4599 20 87.6226C20 76.7854 11.0457 68 0 68V10Z"
                fill="url(#paint0_linear_3208_27366)"
            />
            <path
                d="M327 68V70H329V68H327ZM327 107.245H329V105.245H327V107.245ZM0 107.245V105.245H-2V107.245H0ZM0 68H-2V70H0V68ZM10 -2C3.37258 -2 -2 3.37258 -2 10H2C2 5.58172 5.58172 2 10 2V-2ZM317 -2H10V2H317V-2ZM329 10C329 3.37258 323.627 -2 317 -2V2C321.418 2 325 5.58172 325 10H329ZM329 68V10H325V68H329ZM309 87.6226C309 77.9257 317.023 70 327 70V66C314.886 66 305 75.645 305 87.6226H309ZM327 105.245C317.023 105.245 309 97.3196 309 87.6226H305C305 99.6002 314.886 109.245 327 109.245V105.245ZM329 148V107.245H325V148H329ZM317 160C323.627 160 329 154.627 329 148H325C325 152.418 321.418 156 317 156V160ZM10 160H317V156H10V160ZM-2 148C-2 154.627 3.37258 160 10 160V156C5.58173 156 2 152.418 2 148H-2ZM-2 107.245V148H2V107.245H-2ZM18 87.6226C18 97.3196 9.97721 105.245 0 105.245V109.245C12.1142 109.245 22 99.6002 22 87.6226H18ZM0 70C9.97721 70 18 77.9257 18 87.6226H22C22 75.645 12.1142 66 0 66V70ZM-2 10V68H2V10H-2Z"
                fill="url(#paint1_linear_3208_27366)"
                mask="url(#path-1-inside-1_3208_27366)"
            />
            <defs>
                <linearGradient id="paint0_linear_3208_27366" x1="187.959" y1="-228.113" x2="463.189" y2="360.065" gradientUnits="userSpaceOnUse">
                    <stop offset="0.0593887" stopColor="#3F68E0" />
                    <stop offset="0.315206" stopColor="#071B31" />
                    <stop offset="0.329737" stopColor="#071A2F" />
                    <stop offset="0.538019" stopColor="#05121F" />
                    <stop offset="0.69452" stopColor="#001934" />
                    <stop offset="1" stopColor="#3F68E0" />
                </linearGradient>
                <linearGradient id="paint1_linear_3208_27366" x1="-6.50037" y1="-92.2841" x2="430.715" y2="120.256" gradientUnits="userSpaceOnUse">
                    <stop offset="0.108269" stopColor="#2F2F2F" />
                    <stop offset="0.587124" stopColor="#C9C9C9" />
                    <stop offset="0.899897" stopColor="#363636" />
                </linearGradient>
            </defs>
        </svg>
    );
}
